import { ProductCardData, ProductSmallCardData } from "../product-card-display";

export enum DocumentType {
  products = 'Products',
  programs = 'Programs'
}

export enum ProductType {
  he = 'HEDocument',
  professional = 'ProfessionalDocument',
  segProduct = 'SEGProductDocument',
  segProgram = 'SEGProgramDocument'
}

export interface ProductTermData {
  term?: string;
  itemType?: string;
  offerType?: string;
}

export interface PdpSmallCardTemplateParams {
  product?: ProductCardData | ProductSmallCardData;
  isCreateEbook?: boolean;
  headingLevel: string;
  showFullTitle: boolean;
  store?: string;
  productIndex?: number;
  onShowTitle: (event: MouseEvent) => void;
}
